import * as React from 'react'
import { CheckinFinalisedNotification } from '../../../../store/modules/notifications'
import { FormattedDateTime } from 'components/formatted-datetime'

export type CheckinFinalisedProps = {
  notification: CheckinFinalisedNotification
}

export const CheckinFinalisedContent: React.VFC<CheckinFinalisedProps> = (
  props
) => {
  const { notification } = props

  return (
    <div className="flex flex-col gap-y-0.5">
      <div>
        You completed a Check-in
        {notification.author && (
          <>
            {' '}
            with{' '}
            <strong className="font-bold">
              {notification.author.fullName}
            </strong>
          </>
        )}
      </div>
      <div className="flex flex-row items-center justify-between gap-2 flex-wrap">
        <span className="text-theme-40">View Check-in summary</span>
        <FormattedDateTime
          className="text-gray-600 text-xs"
          date={notification.createdAt}
        />
      </div>
    </div>
  )
}
